/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class DataSheetsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      staff: this.store.query('person', { type: PersonType.STAFF }),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
  }
}
